import { ProductEventDataList, RecommendationsSliderTypeKey as Type } from 'corgi-types';

import { RecoSliderPosition } from 'common/enums/RecommendationsSlider';
import {
  CONFIG_DEFAULT,
  CONFIG_DEFAULT_SMALL,
  CONFIG_DRAWER,
  CONFIG_DRAWER_SMALL,
  CONFIG_WITH_BACKGROUND,
  CONFIG_WITH_BACKGROUND_SMALL,
} from './constants';

interface GetListEventValueParams {
  eventDataList?: ProductEventDataList;
  type?: Type;
}
/**
 * @todo replace this map by corgi component list prop
 * https://home24.atlassian.net/browse/FP-2612
 */
export const getListEventValue = ({ eventDataList, type }: GetListEventValueParams) => {
  if (eventDataList) {
    return eventDataList;
  }
  if (!type) {
    return undefined;
  }

  return new Map<Type, ProductEventDataList>([
    [Type.CartEmpty, ProductEventDataList.CartEmptyRecoSlider],
    [Type.Cart, ProductEventDataList.CartRecoSlider],
    [Type.Homepage, ProductEventDataList.Homepage],
    [Type.ShopTheLook, ProductEventDataList.ShopTheLook],
    [Type.PlpOne, ProductEventDataList.PlpRecoSliderOne],
    [Type.PlpTwo, ProductEventDataList.PlpRecoSliderTwo],
    [Type.PdpOne, ProductEventDataList.PdpRecoSliderOne],
    [Type.PdpTwo, ProductEventDataList.PdpRecoSliderTwo],
    [Type.PdpThree, ProductEventDataList.PdpRecoSliderThree],
    [Type.PdpFour, ProductEventDataList.PdpRecoSliderFour],
    [Type.SearchNoResults, ProductEventDataList.SearchNoResultsRecoSlider],
    [Type.HelpSubmission, ProductEventDataList.HelpSubmissionRecoSlider],
    [Type.Wishlist, ProductEventDataList.WishlistRecoSlider],
    [Type.WishlistNoResults, ProductEventDataList.WishlistNoResultsRecoSlider],
    [Type.AddToCart, ProductEventDataList.AddToCartRecoSlider],
  ]).get(type);
};

export const getConfig = (
  position: RecoSliderPosition,
  withBackground?: boolean,
  isSmallVariant?: boolean
) => {
  if (withBackground) {
    return isSmallVariant ? CONFIG_WITH_BACKGROUND_SMALL : CONFIG_WITH_BACKGROUND;
  }

  if (position === RecoSliderPosition.Default) {
    return isSmallVariant ? CONFIG_DEFAULT_SMALL : CONFIG_DEFAULT;
  }

  return isSmallVariant ? CONFIG_DRAWER_SMALL : CONFIG_DRAWER;
};
